import React, { useState, useEffect } from 'react'
import { Steps,} from 'antd'
import { useTDspjdListQuery } from '../../store/DianShangYeWuApi';
function ReportCheckNodePendding(props) {
    const [items, setItems] = useState([]); 
    //审批节点    
    const {data, isSuccess} = useTDspjdListQuery({dsbzd_spjd_qy_id:props.qy_id,dsbzd_spjd_user_id:props.yh_id},{skip:!props.yh_id});
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            // 创建数组副本后再排序，避免修改只读数组
            const sortedData = [...data.Result].sort((a, b) => {
                return a.dsbzd_spjd_xuhao - b.dsbzd_spjd_xuhao;
            })
            const arr = sortedData.map((item) => ({
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.dsbzd_spjd_name}</span>       ,
                content:<span style={{fontSize:"12px"}}>{item.dsbzd_spjd_yh_name}</span>,
            }))
            setItems([{
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                content:<span style={{fontSize:"12px"}}>{props.yh_name} {props.dsbzd_ctime}</span>,
            },
            {
                title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
            },...arr]);
        }
    }, [data, isSuccess,props.qy_id,props.yh_id,props.dsbzd_ctime,props.yh_name]);
    
    return (
        <Steps items={items} current={0} size="small" titlePlacement="vertical" />
    )
}

export default ReportCheckNodePendding